import React from 'react';

const ComponentEditProfile = () => {
  return (
    <div>
      ComponentEditProfile
    </div>
  );
};

export default ComponentEditProfile;